import styles from "./List.module.css";

export interface ListProps<T> {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  style?: React.CSSProperties;
  emptyPlaceholder?: React.ReactNode;
}

export const List = <T,> ({
  items,
  renderItem,
  style,
  emptyPlaceholder,
}: ListProps<T>) => {
  return (
    <div className={styles.container} style={style}>
      {items.length ? (
        items.map((item, index) => (
          <div key={index}>
            {renderItem(item)}
          </div>
        ))
      ) : (
        <div className={styles.placeholderContainer}>
          {emptyPlaceholder}
        </div>
      )}
    </div>
  );
};